import React, {useEffect} from "react";

const PrivacyPolicy = () => {
   useEffect(() => {
          document.title = "Privacy Policy - EAP Finance"; // Changed to EAP Finance
        }, []);
  return (
    <div className="bg-[#ffffff] min-h-screen flex items-center justify-center">
      <section className="max-w-6xl w-full mx-auto px-6 sm:px-10 lg:px-16 py-24 text-center">
        {/* Header */}
        <header className="my-8 ">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#000300] mb-4">
            EAP Finance Privacy Policy
          </h1>
          <p className="text-lg text-gray-600">Effective Date: January 11, 2025</p>
        </header>

        {/* Content */}
        <div className="grid grid-cols-1 gap-10 text-[#000300]">
          {/* Section Wrapper */}
          {sections.map(({ title, content }, index) => (
            <section key={index} className="text-left">
              <h2 className="lg:text-2xl sm:text-3xl font-semibold text-[#000300] mb-4">
                {title}
              </h2>
              {Array.isArray(content) ? (
                <ul className="list-disc pl-6 space-y-2 lg:text-lg text-[#000300]">
                  {content.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p className="lg:text-lg">{content}</p>
              )}
            </section>
          ))}

          {/* Contact Section */}
          <section className="text-left">
            <h2 className="text-2xl sm:text-3xl font-semibold text-[#000300] mb-4">
              Contact Us
            </h2>
            <p>
              If you have any questions or concerns regarding this policy, please contact us:
            </p>
            <p className="font-semibold text-[#000300]">Email: contact@eapfinance.com</p>
          </section>
        </div>

        {/* Footer */}
        <footer className="pt-12 text-center">
          <p className="text-sm sm:text-base font-semibold text-[#000300]">
            By engaging with EAP Finance, you acknowledge that you've read and accepted this privacy policy.
          </p>
        </footer>
      </section>
    </div>
  );
};

const sections = [
  {
    title: "Information We Collect",
    content: [
      "Contact details (name, email, phone number, address)",
      "Financial information (income, assets, liabilities, investment goals)",
      "Identification documents (ID, passport, tax ID number)",
    ],
  },
  {
    title: "How We Use Your Information",
    content: [
      "Provide personalized financial services and investment advice",
      "Manage your accounts and process transactions",
      "Comply with regulatory requirements and legal obligations",
    ],
  },
  {
    title: "Information Sharing With",
    content: [
      "Affiliated companies and third-party service providers",
      "Regulatory bodies and law enforcement agencies (as required by law)",
      "Your authorized representatives (with your consent)",
    ],
  },
  {
    title: "Data Security",
    content:
      "We implement robust technical and organizational measures to protect your information from unauthorized access, loss, or disclosure.",
  },
  {
    title: "Your Rights",
    content: [
      "Access and correct your information",
      "Request data deletion or restriction of processing",
      "Object to processing for legitimate reasons",
    ],
  },
  {
    title: "Changes to This Policy",
    content:
      "We may update this policy periodically. We'll notify you of significant changes.",
  },
];

export default PrivacyPolicy;